import { useTheme } from '@mui/material';
import Paper from '@mui/material/Paper';

import type { CSSProperties } from 'react';

interface UpcomingPluginCardProps {
  name: string;
  logo: string;
  logoStyle?: CSSProperties;
}

const UpcomingPluginCard = (props: UpcomingPluginCardProps) => {
  const theme = useTheme();

  return (
    <Paper
      variant="outlined"
      className="flex h-16 w-full items-center justify-center overflow-hidden"
      sx={{
        borderRadius: '12px',
        borderStyle: 'dashed',
        borderColor: theme.palette.grey[200],
      }}
    >
      <img
        src={props.logo}
        alt={`${props.name} (próximamente)`}
        style={{
          height: 22,
          maxWidth: '120px',
          filter: 'grayscale(100%)',
          opacity: 0.6,
          ...props.logoStyle,
        }}
      />
    </Paper>
  );
};

export default UpcomingPluginCard;
